import http from "../http/http-config";
import { ValidatePhone } from "../models/validatePhone";

export default new class PhoneService {
    validatePhone(areaCode, phoneNumber): Promise<ValidatePhone> {
        return http.get<ValidatePhone>("Phone", {
            params: {
                areaCode,
                phoneNumber
            }
        }).then(response => response.data)
    }
}